import React, {useState, useEffect} from 'react';
import { getAssigment } from '../../api/Assigment';


function AssignmentList({refresh, setRefresh}) {
  const [loading, setLoding] = useState(false);
  const [assigment, setAssigment] = useState([]);

   useEffect(()=>{
      setLoding(true);
      setRefresh(true);
      getAssigment((result) =>{
         if(result.ok === 1){
            setAssigment(result.result);
            setRefresh(false);
           return setLoding(false);
         }
        
      })
   },[])

   
    return (
        <div class="container mt-4">
        <div className='row justify-content-center'>
          <div className='row'>
              <div className='col md-6'>
                 <div className='row'>
                  <div className='col md-4'>
                      
                  </div>
                  <div className='col md-4'>
                 
                  </div>
                  <div className='col md-4'>
                  
                  </div>
                 </div>
                </div> 
            </div> 
        </div>
<table class="table mt-2 table-striped table-bordered table-hover table-md">
<thead class="thead-dark">
  <tr>
    <th><strong>#</strong></th>
    <th><strong>Assginment Name</strong></th>
    <th><strong>Duration (Days)</strong></th>
    <th><strong>Points (out of 100%)</strong></th>
    <th><strong></strong></th>
  </tr>
</thead>
<tbody>
  
  {assigment.map((item) =>(
    <tr>
    <td>1</td>
      <td>{item.assign_name}</td>
      <td>{item.duration} days</td>
      <td>{item.point} %</td>
      <td>
       <i className='fa fa-edit m-3'></i>
       <i className='fa fa-trash m-3'></i>
      </td>
    </tr>
  ))}
 
</tbody>
</table>


</div>
    );
}

export default AssignmentList;